import { media, styled } from '@styles';

export const AddToCartSection = styled.div`
  display: flex;
  flex-direction: column;
  margin: 15px 15px 15px 0;
  background: #ffffff;
  border-radius: 10px;
  overflow: hidden;
  z-index: 1;
  // max-height: 90%;
  width: 100%;
  ${media.mediumScreen`
    width: 100%;
    margin: 20px 40px;
    // height: auto;
  `}
  ${media.smallScreen`
    margin: 5px 10px;
    // height: auto;
  `}
`;

export const ContentContainer = styled.div`
  padding: 25px 48px 25px 48px;
  overflow: auto;
  ${media.largeScreen`
    padding: 20px 40px;
  `}
  ${media.mediumScreen`
    padding: 10px 20px 10px;
  `}
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  ${media.largeScreen`
    margin-top: 0;
    margin-bottom: 10px;
  `}
  ${media.smallScreen`
    margin-bottom: 6px;
  `}
`;

export const ProductNameHeader = styled.h1`
  font-family: ${({ theme: { typography } }) => typography.thinFontFamily};
  font-size: ${({ theme: { typography } }) => typography.h5FontSize};
  line-height: 110%;
  align-items: center;
  text-transform: capitalize;
  ${media.xLargeScreen`
    line-height: 110%;
  `}
  ${media.smallScreen`
    line-height: 110%;
  `}
`;

export const ProductPricing = styled.h4`
  font-style: normal;
  font-weight: 500;
  font-size: ${({ theme: { typography } }) => typography.h5FontSize};
  line-height: 110%;
`;

export const UndiscountedPrice = styled.span`
  white-space: nowrap;
  font-size: ${({ theme: { typography } }) => typography.baseFontSize};
  span {
    position: relative;
  }
  span:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    background-color: ${(props) => props.theme.colors.grayDark};
    border-radius: 2px;
    top: 50%;
    left: 0;
  }
`;

export const EstimatedShipping = styled.div`
  margin-left: auto;
  font-family: ${({ theme: { typography } }) => typography.extraFontFamily};
  font-size: ${({ theme: { typography } }) => typography.labelFontSize};
  line-height: 160%;
  text-align: right;
  color: ${({ theme: { colors } }) => colors.graySemi};
  margin-bottom: 10px;
  ${media.xLargeScreen`
    line-height: 160%;
  `}
  ${media.mediumScreen`
    margin-bottom: 10px;
  `}
`;

export const VariantPicker = styled.div``;

export const QuantityInput = styled.div``;

export const ErrorMessage = styled.p`
  color: ${(props) => props.theme.colors.error};
  text-align: center;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding: 14px 18px;
  border-top: 1px solid #e9e9e9;
  ${media.smallScreen`
    flex-direction: column;
    padding: 0px 18px 10px 18px;
  `}
`;

export const QuantityContainer = styled.div`
  ${media.smallScreen`
    padding-top: 10px;
    display: none;
`}
`;

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  width: 100%;
  ${media.smallScreen`
    padding-top: 10px;
  `}
`;
